export const datesFormat = {
    uk: {
        long: 'DD MMM YYYY',
        short: 'MMM DD YYYY',
        longWithTime: 'DD MMM YYYY HH:mm',
        shortWithTime: 'MMM DD YYYY HH:mm',
    },
    en: {
        long: 'MMM DD YYYY',
        short: 'DD MMM YYYY',
        longWithTime: 'MMM DD YYYY HH:mm',
        shortWithTime: 'DD MMM YYYY HH:mm',
    },
};
